export class TracercoColours {
    static Grey: string = "#7c878e";
    static PaleGrey: string = "#ebebeb";
    static Background: string = "#ffffff";
}
